import { LineAPI } from '../../../api/datamanager/LineAPI';

export class LinesDraftCommand {
    get(edition, providerId, successCallback, errorCallback) {
        const apiResult = LineAPI.listDraft(edition.draftNetwork, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("[Rascunho] Ocorreu um erro a ler as linhas");
            }
        });
    }

    getWithActive(edition, providerId, successCallback, errorCallback) {
        const apiResult = LineAPI.listWithActiveDraft(edition.network, edition.draftNetwork, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("[Rascunho] Ocorreu um erro a ler as linhas");
            }
        });
    }

    count(draftNetworkEdition, providerId, successCallback, errorCallback) {
        const apiResult = LineAPI.countDraft(draftNetworkEdition, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, line, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(undefined === line.id || 0 === line.id) {
            apiResult = LineAPI.createDraft(edition.draftNetwork, line);
            successMessage = "Linha criada com sucesso";
        }
        else {
            apiResult = LineAPI.updateDraft(edition.draftNetwork, line.id, line);
            successMessage = "Linha editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, lineId, successCallback, errorCallback) {
        const apiResult = LineAPI.deleteDraft(edition.draftNetwork, lineId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Linha eliminada com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/LinesDraftCommand.js